export default __webpack_public_path__ + "media/Habits.bb717f5a.svg";